// в будущем может появится: warning, error, success, primary
export enum BtnTypesEnum {
  Default = 'default'
}
